/**
 * Event puzzles — moments in time the audience lived through, plus widely
 * recognized historical landmarks. No specific dates required; titles only.
 */
export const EVENTS = [
  'A WEDDING ANNIVERSARY',
  'A FAMILY REUNION',
  'A SUMMER VACATION',
  'A SUNDAY PICNIC',
  'A NEW YEARS EVE PARTY',
  'A BIRTHDAY CELEBRATION',
  'A GRADUATION CEREMONY',
  'A CHRISTMAS MORNING',
  'A THANKSGIVING DINNER',
  'A FOURTH OF JULY PARADE',
  'A LABOR DAY BARBECUE',
  'A SAINT PATRICKS DAY PARADE',
  'A VALENTINES DAY DINNER',
  'AN EASTER EGG HUNT',
  'A HALLOWEEN COSTUME PARTY',
  'A MEMORIAL DAY PARADE',
  'A COUNTY FAIR',
  'A STATE FAIR',
  'A SUMMER CARNIVAL',
  'A WINTER CARNIVAL',
  'A BARN DANCE',
  'A SQUARE DANCE',
  'A SUNDAY CHURCH SERVICE',
  'A HARVEST FESTIVAL',
  'A HOMECOMING PARADE',
  'AN OLD FASHIONED HOEDOWN',
  'A QUILTING BEE',
  'A FARMERS MARKET',
  'A FIRST DAY OF SCHOOL',
  'A SCHOOL PLAY',
  'A HIGH SCHOOL DANCE',
  'A COLLEGE GRADUATION',
  'A SUMMER WEDDING',
  'A SPRING FORMAL',
  'A SWEET SIXTEEN PARTY',
  'A BAR MITZVAH CEREMONY',
  'A BAPTISM',
  'A HOUSE WARMING',
  'A RETIREMENT PARTY',
  'A SURPRISE BIRTHDAY PARTY',
  'A BABY SHOWER',
  'A BRIDAL SHOWER',
  'OPENING NIGHT AT THE THEATER',
  'A NIGHT AT THE OPERA',
  'A SUMMER CONCERT IN THE PARK',
  'A SYMPHONY EVENING',
  'AN OLD TIME REVIVAL',
  'A WORLD SERIES GAME',
  'AN OPENING DAY AT THE BALLPARK',
  'A HEAVYWEIGHT TITLE FIGHT',
  'THE KENTUCKY DERBY',
  'THE ROSE BOWL PARADE',
  'THE MOON LANDING',
  'THE SIGNING OF THE DECLARATION',
  'THE BOSTON TEA PARTY',
  'THE BATTLE OF GETTYSBURG',
  'THE GREAT CHICAGO FIRE',
  'THE WORLDS FAIR',
  'A SUMMERTIME ROAD TRIP',
  'A CROSS COUNTRY TRAIN RIDE',
  'A TRANSATLANTIC OCEAN VOYAGE',
  'THE FIRST DAY OF SPRING',
  'THE LAST DAY OF SUMMER',
  'A QUIET SUNDAY AFTERNOON',
  'A LATE NIGHT AT THE DINER',
  'AN EARLY MORNING SUNRISE',
  'A WALK ALONG THE BEACH',
  'A WALK THROUGH THE WOODS',
  'A HORSE DRAWN CARRIAGE RIDE',
  'A SLEIGH RIDE IN THE SNOW',
  'A DAY AT THE BEACH',
  'A NIGHT AT THE DRIVE IN',
  'A SODA FOUNTAIN VISIT',
  'A NIGHT OUT DANCING',
  'A FAMILY GAME NIGHT',
  'A QUIET EVENING AT HOME',
  'A LIBRARY READING HOUR',
  'A POETRY READING',
  'A CHURCH SUPPER',
  'A CHURCH PICNIC',
] as const;
